import { ProductCategory } from '../constants/products';

export function deriveProductCategory(product) {
  const isMens = product.productCategoryIdList.includes(ProductCategory.mens);
  const isWomens = product.productCategoryIdList.includes(
    ProductCategory.womens
  );
  return {
    isMens,
    isWomens,
  };
}
